export enum PeriodoArrecadacaoEnum {
  Unico = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  Sempre = "6F015783-EA54-4F9D-AE2F-14025749C5B3",
  VariosMeses = "ECBFAD7A-868D-4446-9547-4B7103D3A5AE",
}

export enum FormaExibirFracaoEnum {
  Decimal = "6F015783-EA54-4F9D-AE2F-14025749C5B3",
  Percentual = "ECBFAD7A-868D-4446-9547-4B7103D3A5AE",
  FormatoOriginal = "9854FE64-0499-48F8-8152-5A83D2518ABF",
}

export enum FormaDistribuicaoArrecadacaoEnum {
  TodasUnidades = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  GrupoUnidades = "6F015783-EA54-4F9D-AE2F-14025749C5B3",
  UnicaUnidade = "ECBFAD7A-868D-4446-9547-4B7103D3A5AE",
  Consumo = "9854FE64-0499-48F8-8152-5A83D2518ABF",
}

export enum TipoArrecadacaoEnum {
  ValorIgualTodasUnidades = "EA3483A3-D908-425F-8171-539752A04E02",
  ValorObtidoRateioDespesa = "6F015783-EA54-4F9D-AE2F-14025749C5B3",
  ValorObtidoPrevisaoOrcamentaria = "ECBFAD7A-868D-4446-9547-4B7103D3A5AE",
  DespesaMesAnterior = "9854FE64-0499-48F8-8152-5A83D2518ABF",
  ValorPorIndexador = "DE753D95-1AC3-442B-87DF-951818D7ADA4",
  ValorDiferenteCadaUnidade = "BCD867EF-7B1B-4F43-BE47-3F33DD4AC903",
  ValorTotalRateado = "87E8DF22-8CFE-4D5C-A4A3-B1CADD59900C",
  ValorMetrosUnidade = "0692B7D6-C0D3-47E8-846E-47F14BF649EF",
  ConsumoAguaGasEnergia = "AAE8DF22-8CFE-4D5C-A4A3-B1CADD59900C",
}

export enum ArrecadacaoAutomaticaMesConsumoEnum {
  MesProcessamento = "mes-processamento",
  MesAnteriorProcessamento = "mes-anterior-processamento",
}

export enum ArrecadacaoAutomaticaPeriodoDemonstrativoEnum {
  MesAnteriorAteVencimento = "mes-anterior-vencimento",
  MesAnteriorAteProcessamento = "mes-anterior-processamento",
  MesAtualAteVencimento = "mes-atual-vencimento",
  MesAtualAteProcessamento = "mes-atual-processamento",
}

export enum ArrecadacaoDemonstrativoContasBancariasEnum {
  Todas = "todas",
  SomenteCobranca = "somenteDaCobranca",
}
